import React, { useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import HomeLayout from "../HomeLayout/HomeLayout"
import CoolLightbox from "../LightBox/CoolLightBox"
const Page2 = ({onChange}) => {
  const [isOpen, setOpen] = useState(false)
  const [currentImageIndex, setCurrentIndex] = useState(0)

  const data = useStaticQuery(graphql`
    query {
      Page2: allFile(
        sort: { order: ASC, fields: name }
        filter: { sourceInstanceName: { eq: "BrandingPage2" } }
      ) {
        nodes {
          id
          name
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      BrandingInfoPage2: allFile(
        sort: { order: ASC, fields: name }
        filter: { sourceInstanceName: { eq: "BrandingInfoPage2" } }
      ) {
        nodes {
          id
          name
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  `)
  var images = []
  data.BrandingInfoPage2.nodes.map(img => {
    var src = img.childImageSharp.fluid.src
    images.push({
      src,
    })
  })
  return (
    <HomeLayout>
        <>
          {data.Page2.nodes.map((img, index) => {
            if(index===6) return <Img fluid={img.childImageSharp.fluid} />
            return (
              <div
                onClick={() => {
                  setCurrentIndex(index)
                  setOpen(true)
                  onChange(false)
                }}
              >
                <Img fluid={img.childImageSharp.fluid} />
              </div>
            )
          })}
          <CoolLightbox 
            images={images}
            setCurrentIndex={setCurrentIndex}
            currentImageIndex={currentImageIndex}
            isOpen={isOpen}
            onClose={() => {setOpen(false) 
              onChange(true)}}
          />
          
        </>
        </HomeLayout>
  )
}
export default Page2

